import script from "./referencePage.vue?vue&type=script&setup=true&lang=js"
export * from "./referencePage.vue?vue&type=script&setup=true&lang=js"

import "./referencePage.vue?vue&type=style&index=0&id=6c985904&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c985904"]])

export default __exports__